// frontend/src/services/detailService.js

import { configuredAxios as api } from './axiosConfig';

// Helper para construir a base da URL de assets (sem /api)
const getAssetBaseUrl = () => {
  const base = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  return base.replace(/\/api$/, '');
};

const detailService = {
  getMatchDetails: async (matchId) => {
    try {
      const response = await api.get(`/matches/${matchId}/details`);
      console.log('Match details (from detailService):', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching match details:', error.response?.data || error.message);
      throw error;
    }
  },

  getTeamLogoUrl: (badgeFileName) => {
    if (!badgeFileName) return null;
    return `${getAssetBaseUrl()}/uploads/${badgeFileName}`;
  },

  updateMatchScore: async (matchId, scoreA, scoreB) => {
    try {
      const response = await api.put(`/matches/${matchId}/score`, { scoreA, scoreB });
      return response.data;
    } catch (error) {
      console.error('Error updating score:', error);
      throw error;
    }
  },

  addGoal: async (matchId, goalData) => {
    try {
      const response = await api.post(`/matches/${matchId}/goals`, goalData);
      return response.data;
    } catch (error) {
      console.error('Error adding goal:', error);
      throw error;
    }
  },

  removeGoalByIndex: async (matchId, goalIndex) => {
    try {
      const response = await api.delete(`/matches/${matchId}/goals/${goalIndex}`);
      return response.data;
    } catch (error) {
      console.error('Error removing goal by index:', error.response?.data || error.message);
      throw error;
    }
  },

  removeGoal: async (matchId, goalId) => {
    try {
      const response = await api.delete(`/matches/${matchId}/goals/id/${goalId}`);
      return response.data;
    } catch (error) {
      console.error('Error removing goal by ID:', error.response?.data || error.message);
      throw error;
    }
  },

  addCard: async (matchId, cardData) => {
    try {
      // cardData deve conter { player: idDoMembro, team, type, minute, reason }
      // O backend geralmente aceita o ID tanto para jogadores quanto para comissão se a rota for unificada.
      const response = await api.post(`/matches/${matchId}/cards`, cardData);
      return response.data;
    } catch (error) {
      console.error('Error adding card:', error.response?.data || error.message);
      throw error;
    }
  },

  removeCard: async (matchId, cardId) => {
    try {
      const response = await api.delete(`/matches/${matchId}/cards/id/${cardId}`);
      return response.data;
    } catch (error) {
      console.error('Error removing card:', error.response?.data || error.message);
      throw error;
    }
  },

  updateMatchStatus: async (matchId, status) => {
    try {
      const response = await api.put(`/matches/${matchId}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating status:', error);
      throw error;
    }
  },

  finalizeMatch: async (matchId) => {
    try {
      const response = await api.patch(`/matches/${matchId}/finalize`, {});
      return response.data;
    } catch (error) {
      console.error('Erro ao finalizar partida:', error.response?.data || error.message);
      throw error;
    }
  },

  removeAllGoals: async (matchId) => {
    try {
      const response = await api.delete(`/matches/${matchId}/goals`);
      return response.data;
    } catch (error) {
      console.error('Error removing all goals:', error.response?.data || error.message);
      throw error;
    }
  },

  resetMatch: async (matchId) => {
    try {
      const response = await api.put(`/matches/${matchId}/reset`, {});
      return response.data;
    } catch (error) {
      console.error('Erro ao resetar partida:', error.response?.data || error.message);
      throw error;
    }
  },

  removePlayerFromLineup: async (matchId, team, playerId) => {
    try {
      const response = await api.delete(
        `/matches/${matchId}/lineup/${team}/player/${playerId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error removing player:', error.response?.data || error.message);
      throw error;
    }
  },

  togglePlayerSuspension: async (matchId, team, playerId) => {
    try {
      const response = await api.patch(`/matches/${matchId}/lineup/${team}/player/${playerId}/suspend`);
      return response.data;
    } catch (error) {
      console.error('Error toggling player suspension:', error.response?.data || error.message);
      throw error;
    }
  },

  // ✅ FUNÇÃO PARA SINCRONIZAR ESCALAÇÕES
  syncMatchLineups: async (matchId) => {
    try {
      const response = await api.patch(`/matches/${matchId}/sync-lineups`);
      return response.data;
    } catch (error) {
      console.error('Erro ao sincronizar escalações:', error.response?.data || error.message);
      throw error;
    }
  },

  // ✅✅✅ NOVA FUNÇÃO PARA ACIONAR VERIFICAÇÃO DE SUSPENSÕES ✅✅✅
  triggerSuspensionCheck: async (matchId) => {
    try {
      const response = await api.post(`/matches/${matchId}/trigger-suspension-check`);
      return response.data;
    } catch (error) {
      console.error('Erro ao acionar verificação de suspensões:', error.response?.data || error.message);
      throw error;
    }
  }
};

export default detailService;